export const navbar = {
	size: '50px',
};
